var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddsquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7933 1.33203H5.20668C2.78001 1.33203 1.33334 2.7787 1.33334 5.20536V10.7854C1.33334 13.2187 2.78001 14.6654 5.20668 14.6654H10.7867C13.2133 14.6654 14.66 13.2187 14.66 10.792V5.20536C14.6667 2.7787 13.22 1.33203 10.7933 1.33203ZM10.6667 8.4987H8.50001V10.6654C8.50001 10.9387 8.27334 11.1654 8.00001 11.1654C7.72668 11.1654 7.50001 10.9387 7.50001 10.6654V8.4987H5.33334C5.06001 8.4987 4.83334 8.27203 4.83334 7.9987C4.83334 7.72536 5.06001 7.4987 5.33334 7.4987H7.50001V5.33203C7.50001 5.0587 7.72668 4.83203 8.00001 4.83203C8.27334 4.83203 8.50001 5.0587 8.50001 5.33203V7.4987H10.6667C10.94 7.4987 11.1667 7.72536 11.1667 7.9987C11.1667 8.27203 10.94 8.4987 10.6667 8.4987Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddsquare);
export default __webpack_public_path__ + "static/media/addsquare.a70b1b30a92e7b67d55b53bd234723a3.svg";
export { ForwardRef as ReactComponent };